import { render, staticRenderFns } from "./NaikinimasArchyvaras.vue?vue&type=template&id=5e02bca9&"
import script from "./NaikinimasArchyvaras.vue?vue&type=script&lang=js&"
export * from "./NaikinimasArchyvaras.vue?vue&type=script&lang=js&"
import style0 from "./NaikinimasArchyvaras.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VContainer,VDataTable,VSpacer,VToolbar})
